import React from 'react';
import { ChainId } from '@uniswap/sdk-core';
import { IControlPositionTypeFilter, IPoolMarketFilter, IPoolTypeFilter } from './types';
import { EControlPositionType, EPoolType } from '../../../../types/uniswapTokens';
import { EMarketName } from '../../../../ui-config/marketsConfig';
import CamelotIcon from '/public/icons/camelot.svg';
import UniswapIcon from '/public/icons/uniswap.svg';
import QuickswapIcon from '/public/icons/quickswap.svg';

export const POOL_TYPE_FILTERS: IPoolTypeFilter[] = [
  {
    value: EPoolType.all,
    label: 'All Pools'
  },
  {
    value: EPoolType.stable,
    label: 'Stable'
  },
  {
    value: EPoolType.volatile,
    label: 'Volatile'
  },
];

export const CONTROL_POSITION_TYPE_FILTERS: IControlPositionTypeFilter[] = [
  {
    value: EControlPositionType.Unknown,
    label: 'All'
  },
  {
    value: EControlPositionType.ManualPosition,
    label: 'Manual'
  },
  {
    value: EControlPositionType.AlmPosition,
    label: 'Automatic'
  },
];

export const POOL_MARKET_FILTERS: IPoolMarketFilter[] = [
  {
    value: EMarketName.None,
    label: 'All Protocols',
    chainIds: [ChainId.MAINNET, ChainId.ARBITRUM_ONE, ChainId.POLYGON],
  },
  {
    value: EMarketName.Uniswap,
    label: 'Uniswap V3',
    icon: <UniswapIcon sx={{ width: '16px', height: '16px' }} />,
    chainIds: [ChainId.MAINNET, ChainId.ARBITRUM_ONE, ChainId.POLYGON],
  },
  {
    value: EMarketName.Camelot,
    label: 'Camelot',
    icon: <CamelotIcon sx={{ width: '16px', height: '16px' }} />,
    chainIds: [ChainId.ARBITRUM_ONE],
  },
  {
    value: EMarketName.Quickswap,
    label: 'Quickswap',
    icon: <QuickswapIcon sx={{ width: '16px', height: '16px' }} />,
    chainIds: [ChainId.POLYGON],
  },
];
